import { createContext, useContext } from 'react';
import { TabType } from '../models/WebAnalytics';

interface HubTabProviderProps {
  value: TabType;
  children?: React.ReactNode;
}

const HubTabContext = createContext<TabType>(TabType.EARNINGS);

const HubTabProvider = ({ value, children }: HubTabProviderProps) => (
  <HubTabContext.Provider value={value}>{children}</HubTabContext.Provider>
);

const useHubTab = (): TabType => useContext(HubTabContext);

export { HubTabProvider, useHubTab };
